import React from 'react';

/** Renders a parsed table block (rows of { text, colspan, rowspan, bold }) with header rows. */
const TablePreview = ({ data, maxRows = 8 }) => {
  const rows = data?.rows || [];
  const headerRows = data?.header_rows || 0;
  const shown = rows.slice(0, Math.max(maxRows, headerRows));
  const renderRow = (row, ri, header) => (
    <tr key={ri}>
      {row.map((cell, ci) => {
        const Tag = header ? 'th' : 'td';
        return (
          <Tag
            key={`${ri}-${ci}`}
            colSpan={cell.colspan > 1 ? cell.colspan : undefined}
            rowSpan={cell.rowspan > 1 ? Math.min(cell.rowspan, shown.length - ri) : undefined}
            className={cell.bold && !header ? 'bold' : undefined}
          >
            {cell.text}
          </Tag>
        );
      })}
    </tr>
  );

  return (
    <div className="dd-table-preview">
      <table>
        {headerRows > 0 && <thead>{shown.slice(0, headerRows).map((r, i) => renderRow(r, i, true))}</thead>}
        <tbody>{shown.slice(headerRows).map((r, i) => renderRow(r, i + headerRows, false))}</tbody>
      </table>
      {rows.length > shown.length && <div className="dd-muted">… {rows.length - shown.length} more rows</div>}
    </div>
  );
};

export default TablePreview;
